/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum KpiCategory {
  Quantity = 'Quantity',
  Time = 'Time',
  Speed = 'Speed',
  Project = 'Project',
  ShiftHeader = 'ShiftHeader',
  ApprovalReport = 'ApprovalReport'
}
